import axios from "axios";//创建一个axios的对象
// 接口根地址：npm run serve 取 .env.development；打包取 .env.production / .env.test
let baseURL=process.env.VUE_APP_BASE_API||"https://test.zgrx.org.cn/"
//生成一个axios的实例
const request=axios.create({
	baseURL:baseURL+'/',// baseURL会在发送请求的时候拼接在url参数前面
	timeout:60*1000*2,//请求超时
    headers:{
        'Content-Type':'application/x-www-form-urlencoded'
    }
});
export {
    request,
    baseURL
};//导出